import routesConfig from 'defs/routes';

export const TUTORIAL_ID: { [key: string]: string } = {
	FEED_OVERVIEW: 'FEED_OVERVIEW',
	FEED_CALENDAR: 'FEED_CALENDAR',
	CARD_DETAIL: 'CARD_DETAIL',
	MY_SUCCESS: 'MY_SUCCESS',
};

export type TutorialIdType = keyof typeof TUTORIAL_ID;

export type TutorialIdsBooleanType = {
	[key: string]: boolean;
};

export type TutorialRouteMatchType = {
	[key: string]: Array<string>;
};
export const TUTORIAL_ROUTE_MATCH: TutorialRouteMatchType = {
	FEED_OVERVIEW: [routesConfig.today.indexRoute.href, routesConfig.today.day.href],
	FEED_CALENDAR: [routesConfig.today.indexRoute.href, routesConfig.today.day.href],
	CARD_DETAIL: [routesConfig.today.indexRoute.href, routesConfig.today.day.href],
	MY_SUCCESS: [routesConfig.mySuccess.indexRoute.href],
};
